<template>
	<div id="Users">
		<div class="row">
			<div v-if="currentUser.gid >= 500" class="col-12">
				<span style="font-size: 13px;">Start with Selecting one of the following user types</span><br>
				<el-radio-group size="default" v-model="userarea" @change="getInitialData()">
					<el-radio-button value="a">Administrators</el-radio-button>
					<el-radio-button value="p">Clients</el-radio-button>
				</el-radio-group>
			</div>
			<div v-if="!OrganizationIDAccess && userarea == 'p'" class="col-12 mt-1">
				<el-select key="orgSelect" v-model="OrganizationID" class="topDropdown" size="default" placeholder="Select Parent Client" @change="getUsers()" default-first-option filterable clearable>
					<el-option
							v-for="item in NonChildOrganizations"
							:label="item.OrganizationName"
							:value="item.OrganizationID"
							:key="item.OrganizationID">
					</el-option>
				</el-select>
			</div>
		</div>
		<div class="row mt-4 mb-4">
			<div class="col-12 col-md-6">
				<div v-if="modifyAccess">
					<div>
						<el-button v-if="OrganizationID || userarea == 'a'" @click.prevent="newUser()" size="default" type="success">Add New User</el-button>
					</div>
				</div>
			</div>
			<div class="col-12 col-md-6">

				<div class="customEmailDropdown" v-if="modifyAccess" >
					<div>
						<p style="float: right; margin-right: 200px; margin-bottom: -2px; font-size: 13px; color: #606266">Welcome Email</p>
					</div>
					<el-select key="customEmailList" prop="CustomWelcomeEmail" style="width: 300px;" size="default" v-model="SystemTextID" placeholder="Select" default-first-option filterable>
						<el-option
								key="welcome"
								label="Default Welcome Email"
								value="welcome">
						</el-option>
                        <template v-for="items in CustomWelcomeEmail" >
						    <el-option
                                v-if="items.CustomTextID == 'welcome'"
								:key="items.SystemTextID"
								:label="items.SystemTextName"
								:value="items.SystemTextID">
						    </el-option>
                        </template>
					</el-select>
				</div>
			</div>
		</div>

		<div class="row">
			<div class="col-12">
				<el-table
					:data="Users"
					stripe border
					max-height="500"
					size="small"
					style="width: 100%">
					<el-table-column
						prop="Contact"
						label="Name"
						min-width="150"
						sortable
					>
						<template #default="scope">
							<span v-if="(scope.row.ContactID === 0 && createAccess) || (modifyAccess && scope.row.operation == 'update')">
								<el-input class="firstname" size="small" v-model="scope.row.FirstName" placeholder="First Name" ></el-input>
								<el-input class="lastname" size="small" v-model="scope.row.LastName" placeholder="Last Name"></el-input>
							</span>
							<span v-else >
								{{ scope.row.Descriptor }}
							</span>
						</template>
					</el-table-column>
					<el-table-column v-if="(userarea == 'p')"
									 prop="AreaName"
									 label="Clients"
									 min-width="250">
						<template #default="scope">
							<span v-if="(scope.row.ContactID === 0 && createAccess) || (modifyAccess && scope.row.operation == 'update')">
								<el-select v-model="scope.row.OrganizationIDs" size="small" class="oneHundred" placeholder="Select" multiple default-first-option filterable>
									<el-option
											v-for="item in ChildOrganizations"
											:label="item.OrganizationName"
											:value="item.OrganizationID"
											:key="item.OrganizationID">
									</el-option>
								</el-select>
							</span>
							<span v-else v-html="scope.row.OrganizationNames"></span>
						</template>
					</el-table-column>
					<el-table-column
						prop="userrole"
						label="Login Role"
						min-width="200">
						<template #default="scope">
							<el-select v-model="scope.row.LoginRoleID" size="small" placeholder="Select" :disabled="currentUser.UserLoginID == scope.row.UserLoginID" style="width:100%;" @change="(!scope.row.operation ? scope.row.operation='update' : '')" default-first-option filterable>
								<template v-for="item in AvailableLoginRole">
                                    <el-option v-if="currentUser.UserLoginID == scope.row.UserLoginID || currentUser.gid > item.gid || currentUser.gid >= 500"
										:key="item.LoginRoleID"
										:label="item.RoleName"
										:value="item.LoginRoleID">
								    </el-option>
                                </template>
							</el-select>
						</template>
					</el-table-column>
					<el-table-column
							prop="EmailAddress"
							label="Email"
							min-width="200"
							sortable
					>
						<template #default="scope">
							<span v-if="(scope.row.ContactID === 0 && createAccess) || (modifyAccess && scope.row.operation == 'update')">
								<el-input v-model="scope.row.EmailAddress" size="small" placeholder="Email" type="email"></el-input>
							</span>
							<span v-else>{{scope.row.EmailAddress}}</span>
						</template>
					</el-table-column>
					<el-table-column
							v-if="userarea == 'p'"
							prop="DownloadCount"
							label="Downloads"
							align="center"
							min-width="100">
						<template #default="scope" >
							<el-tooltip v-if="scope.row.DownloadCount" placement="top" effect="light">
								<div slot="content" v-html="scope.row.DownloadList"></div>
								<span style="cursor:pointer;font-weight:800; font-size: 20px;" v-html="scope.row.DownloadCount"></span>
							</el-tooltip>
						</template>
					</el-table-column>
					<el-table-column
							prop="UserParams.LastLogin"
							label="TimeStamps"
							min-width="160">
						<template #default="scope">
							<span v-if="scope.row.ContactID">
								<span v-if="scope.row.Params.Registration" v-html="'Registration: ' + scope.row.Params.Registration+'<br>'"></span>
								<span v-if="scope.row.Params.Activation" v-html="'Activation: ' + scope.row.Params.Activation+'<br>'"></span>
								<span v-html="'Last Login: ' + scope.row.UserParams.LastLogin"></span>
							</span>
						</template>
					</el-table-column>
					<el-table-column
									 label="Send Email"
									 width="90"
									 align="center">
						<template #default="scope">
							<a href="#" style="font-size: 16px;" v-if="scope.row.UserLoginID && currentUser.UserLoginID != scope.row.UserLoginID" @click.prevent="scope.row.Block='n';sendUserEmail(scope.row);"><i class="far fa-envelope"></i></a>
						</template>
					</el-table-column>
					<el-table-column v-if="modifyAccess"
									 label=""
									 width="120"
									 align="center">
						<template #default="scope">
							<a href="#" style="font-size: 16px;" v-if="currentUser.UserLoginID != scope.row.UserLoginID && scope.row.Block == 'n'" @click.prevent="editUser(scope.$index, scope.row)"><i style="font-weight: 800;" class="far fa-edit"></i></a>
							<a href="#" style="font-size: 16px;" v-if="currentUser.UserLoginID != scope.row.UserLoginID && scope.row.Block == 'n'" @click.prevent="removeCnfm(scope.$index, scope.row)"><i style="margin-left: 30px; font-weight: 800;" class="danger far fa-trash-alt"></i></a>
							<div v-if="scope.row.Block == 'y'" class="danger" ><i class="fas fa-times-circle"></i></div>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<div class="row mt-4" v-if="(modifyAccess || createAccess)" >
			<div class="col-12 text-center">
				<button class="btn btn-success btn-icon" @click="save" style="margin-right: 10px;">
					<i class="fas fa-check"></i> <span> Save Changes</span>
				</button>
				<button class="btn btn-icon btn-dark cancel"  @click="getInitialData">
					<i class="fas fa-times"></i>  <span>Cancel</span>
				</button>
			</div>
		</div>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';
	import axios from 'axios';
    import Util from '../assets/js/util.js';

	const STATUS_INITIAL = 0, STATUS_SAVING = 1, STATUS_SUCCESS = 2, STATUS_FAILED = 3;

	export default {
		name: 'Users',
	    data() {
	        return {
		        userarea: '',
				Organizations : [],
		        OrganizationID : '',
                Users : [],
		        LoginRole: [],
		        AvailableLoginRole: [],
				CustomWelcomeEmail: [],
				SystemTextID: '',
	        }
	    },
	    props:["config"],
	    computed: {
	        ...mapGetters({ currentUser: 'currentUser' }),
		    ...mapGetters({ componentIDs: 'componentIDs' }),
			isInitial() {
				return this.currentStatus === STATUS_INITIAL;
			},
			isSaving() {
				return this.currentStatus === STATUS_SAVING;
			},
			isSuccess() {
				return this.currentStatus === STATUS_SUCCESS;
			},
			isFailed() {
				return this.currentStatus === STATUS_FAILED;
			},
            createAccess () {
                return Util.createAccess(this.currentUser);
            },
            modifyAccess () {
                return Util.modifyAccess(this.currentUser);
            },
		    OrganizationIDAccess () {
			    return Util.OrganizationIDAccess(this.currentUser);
		    },
		    NonChildOrganizations () {
			    let orgs = [];
			    for (let i=0; i < this.Organizations.length; i++) {
				    if (this.Organizations[i].ParentOrganizationID == 0) {
					    orgs.push(this.Organizations[i]);
				    }
			    }
			    return orgs;
		    },
		    ChildOrganizations () {
			    let orgs = [];
			    for (let i=0; i < this.Organizations.length; i++) {
				    if (this.Organizations[i].ParentOrganizationID == this.OrganizationID) {
					    orgs.push(this.Organizations[i]);
				    }
			    }
			    return orgs;
		    },
		},
		methods: {
			CalcAvailableLoginRole () {
				this.AvailableLoginRole = [];
				for (let i = 0; i < this.LoginRole.length; i++) {
					if (!this.OrganizationIDAccess) {
						this.AvailableLoginRole.push( this.LoginRole[i] );
					} else if (this.LoginRole[i].gid >= 500 && this.userarea == 'a') {
						this.AvailableLoginRole.push( this.LoginRole[i] );
					} else if (this.LoginRole[i].gid <= 400 && this.userarea == 'p') {
						this.AvailableLoginRole.push( this.LoginRole[i] );
					}
				}
			},
			getInitialData () {
				if (this.OrganizationIDAccess) {
					this.OrganizationID = this.currentUser.OrganizationID;
					this.userarea = 'p';
				}
				var tables = ['LoginRole','Organizations'];
				axios.post('/index/tableData', {'tables': tables , UserArea : this.userarea },
				)
					.then(response => {
						if (response.data.result == 'success') {
							for (let value of tables) {
								this[value] = response.data[value];
							}
						} else {
						}

						this.getUsers();
					}).catch(response => {
				});
			},
			getUsers() {
				this.Users = [];
				var self = this;

				if(this.userarea == 'a' || (this.userarea == 'p')) {
					axios.post('/users/getall', {
							userarea: this.userarea,
							OrganizationID: this.OrganizationID,
						},
					)
						.then(response => {
							if (response.data.result == 'success') {
								self.$store.dispatch('setID', {'Useruserarea': self.userarea});
								if (this.userarea == 'p') {
									self.$store.dispatch('setID', {'UserOrganizationID': self.OrganizationID});
								}
								this.Users = response.data.Users;
							} else {
							}
							this.CalcAvailableLoginRole();
						}).catch(response => {
					});
				} else {
					this.Users = [];
				}
			},
			getCustomEmails () {
				axios.post('/Users/getcustomemails'	)
						.then(response => {
							if (response.data.result == 'success') {
								if (response.data.CustomEmails) {
									this.CustomWelcomeEmail = response.data.CustomEmails;
								}
							} else {
							}
						}).catch(response => {
				});
			},
			newUser() {
				this.Users.unshift({UserLoginID: 0, ContactID: 0,  OrganizationID : this.OrganizationID, LoginRoleID: '', FirstName: '', LastName: '', EmailAddress: '', OrganizationIDs : [], Params : {avatar:""}, UserParams : {}, operation: 'add'});
			},
			editUser (idx, row) {
				this.Users[idx].operation = 'update';
			},
			save () {
				if (this.currentStatus == STATUS_SAVING) {
					return true;
				}
				this.currentStatus = STATUS_SAVING;

				axios.post('/users/saveall', {Users : this.Users, userarea : this.userarea, OrganizationID : this.OrganizationID }
				)
					.then(response => {
						if (response.data.result == 'success') {
							this.currentStatus = STATUS_INITIAL;;
							this.$notify({
								title: 'Success',
								message: "Users have been saved.",
								type: 'success',
								duration: 1500,
								showClose: false
							});
							this.refreshData();
						} else {
							this.currentStatus = STATUS_FAILED;
							this.displayPopup (response.data.message);
						}
					}).catch(response => {
						this.currentStatus = STATUS_FAILED;
				});

			},
			sendUserEmail(row) {
				if (row.UserLoginID) {
					axios.post('/Users/sendemail', {UserLoginID: row.UserLoginID, EmailAddress: row.EmailAddress, SystemTextID: this.SystemTextID}
					)
						.then(response => {
							if (response.data.result == 'success') {
								this.$notify({
									title: 'Success',
									message: "User Activation Email Sent",
									type: 'success',
									duration: 1500,
									showClose: false
								});
							} else {
								this.$notify({
									title: 'Error',
									message: "User Activation Email Failed",
									type: 'error',
									duration: 2000,
									showClose: false
								});
							}
						}).catch(response => {
						this.$notify({
							title: 'Error',
							message: "User Activation Email Failed",
							type: 'error',
							duration: 2000,
							showClose: false
						});
					});
				}
			},
			removeCnfm (index,row) {
				this.$confirm('You will be deleting this user. Do you wish to continue?', 'Confirmation', {
					confirmButtonText: 'OK',
					type: 'warning',
					showClose: false,
					showCancelButton: true
				}).then(() => {
					this.removeLogin(index, row);
				}).catch(() => {
				});
			},
			removeLogin(index, row) {
				if (row.UserLoginID) {
					if (this.currentUser.ContactID != row.ContactID) {
						axios.post('/users/removelogin', {UserLoginID: row.UserLoginID}
						)
							.then(response => {
								if (response.data.result == 'success') {
									this.refreshData();
									this.$notify({
										title: 'Success',
										message: "User Login has been removed",
										type: 'success',
										duration: 1500,
										showClose: false
									});
								} else {
									this.$notify({
										title: 'Error',
										message: "User Login CANNOT be removed",
										type: 'error',
										duration: 2000,
										showClose: false
									});
								}
							}).catch(response => {
							this.$notify({
								title: 'Error',
								message: "User Login CANNOT be removed",
								type: 'error',
								duration: 2000,
								showClose: false
							});
						});
					} else {
						this.displayPopup('Sorry, you cannot remove yourself');
					}
				} else {
					this.Users.splice(index, 1);
				}
			},
	        displayPopup (message) {
                this.$alert(message, 'Error', {
                    confirmButtonText: 'OK',
					type: 'error',
					dangerouslyUseHTMLString: true
                });
            },
            refreshData() {
                this.getInitialData();
            },
		},
		mounted () {
			if (this.componentIDs.Useruserarea) {
				this.userarea = this.componentIDs.Useruserarea;
			}
			if (this.componentIDs.UserOrganizationID) {
				this.OrganizationID = this.componentIDs.UserOrganizationID;
			}

			this.getInitialData();
			this.getCustomEmails();
		},
	}
</script>
<style>
.Users div.el-table .cell {
	word-break: normal;
}
#app.userlogins table .el-select, table .el-input {
	width: 100%;
}
#app.userlogins .el-select {
	width: 300px;
}
</style>
<style scoped>
#Users .scores {
	width: 40px;
    text-align: center;
    padding: 1px;
    margin: 1px 0px;
    height: 23px;
}

.customEmailDropdown {
	float:right;
}

#Users .row.buttons {
	margin-top: 20px;
}
select.not-available {
	width: auto;
	margin-left: 0px   !important;
}
.not-available label {
	margin-top: 4px;
}
.organization-select {
	font-weight: 800;
	font-size: 110%;
}
.options {
	margin: 0px 5px;
}

.el-input.firstname, .el-input.lastname {
	width: 100%;
	margin-right: 5px;
	margin-bottom: 5px;
}
.danger {
	font-size: 16px;
	display: inline-block;
	color: #dc3545;
}
.organizationName {
	display: inline-block;
	font-weight: 800;
}
</style>
